const doc = [({"no":({"js":({"components":({"user":({"unicorn":({"profile_box":({"profile":"Profil", "independent":"Selvstendig", "active":"Aktiv"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;